import React, { useEffect, useState } from "react";
import AddWorkflowPerformer from "./AddWorkflowPerformer";
import config from "../config.json";
import Pagination from "../comman/pagination";
import PageSizeOptions from "./PageSizeOptions";
import { paginate, calculateIndex } from "../utlis/paginate";
import ActiveDeactiveHistory from "./SystemAdministration/ManagePartner/ActiveDeactiveHistory";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getRolePerformers, loadRolePerformers, getWorkflowRolesLoading } from "../app/store/workflowRole";
import { getLoggedUserDetails, loadUserDetails, getCurrentUser } from "../app/store/auth";
import { addWorkflowPerformer } from "../app/store/users";
import { setCurrentPageTitle, setCurrentRoute } from "../app/store/layoutUI";
import { getFormatedNumber } from "../services/appService";
import Moment from "react-moment";

export default function ManageWorkflowPerformer(props) {
  const route = [
    { url: "/", name: "System Administration" },
    { url: "/", name: "Authorized Users" },
    { url: "/WorkflowUser", name: "Main Users" },
  ];

  const [performers, setPerformers] = useState([]);
  const [rowsCount, setRowsCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [startIndex, setStartIndex] = useState(0);
  const [endIndex, setEndIndex] = useState(5);
  const [selectedObj, setSelectedObj] = useState(null);
  const [currentUser, setCurrentUser] = useState("");
  const [loggedUser, setLoggedUser] = useState("");
  const [performerId, setPerformerId] = useState("");
  const [performerName, setPerformerName] = useState("");
  const [mobile, setMobile] = useState("");
  const [actionType, setActionType] = useState("action");
  const [selectedUserId, setSelectedUserId] = useState(0);
  const [selectedKey, setSelectedKey] = useState("home");
  const [dataType, setDataType] = useState("");
  const [isFiltering, setIsFiltering] = useState(false);
  const performerList = useSelector(getRolePerformers);
  const isLoading = useSelector(getWorkflowRolesLoading);
  const userDetails = useSelector(getLoggedUserDetails);

  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(setCurrentRoute(route));
    dispatch(setCurrentPageTitle("Manage Workflow Role Users"));
    document.body.classList.add("workflow-user-card-scroll");
    return () => {
      document.body.classList.remove("workflow-user-card-scroll");
    };
  }, []);

  useEffect(() => {
    const obj = location?.state;
    if (obj?.roleid) {
      dispatch(loadRolePerformers(obj.roleid));
      setCurrentUser(obj);
    }
  }, []);

  useEffect(() => {
    getPagedData(performerList, currentPage, pageSize);
  }, [performerList]);

  useEffect(() => {
    const user = getCurrentUser();
    if (user?.id) dispatch(loadUserDetails(user.id));
  }, []);

  useEffect(() => {
    const user = getCurrentUser();
    if (user?.type === "admin" && userDetails !== null) {
      setLoggedUser({ ...userDetails, roleType: "admin" });
    }
  }, [userDetails]);

  const handleFormSubmit = async (performer) => {
    if (currentUser?.roleid > 0) {
      performer["roleId"] = currentUser.roleid;
      await dispatch(addWorkflowPerformer(performer));
      dispatch(loadRolePerformers(currentUser.roleid, true));
      handlePermissionShowHide();
    }
  };

  const getPagedData = (list, page, size) => {
    const items = paginate(list, page, size);
    setRowsCount(list.length);
    setPerformers(items);
  };

  // Filter runs on full performerList (not paged slice)
  const handleFilter = () => {
    setIsFiltering(true);
    let filtered = performerList;
    if (performerId !== "")
      filtered = filtered.filter((p) => p.id === parseInt(performerId));
    if (performerName !== "")
      filtered = filtered.filter((x) =>
        x.name.toLowerCase().includes(performerName.toLowerCase())
      );
    if (mobile !== "")
      filtered = filtered.filter((x) => x.contact && x.contact.includes(mobile));
    getPagedData(filtered, 1, pageSize);
    setDataType("filter");
    setTimeout(() => {
      setIsFiltering(false);
    }, 600);
  };

  const handleFilterCancel = () => {
    getPagedData(performerList, 1, pageSize);
    setPerformerId("");
    setPerformerName("");
    setMobile("");
    setDataType("");
    setIsFiltering(false);
  };

  const formatPhoneNumber = (value) => {
    if (!value) return value;
    const n = value.replace(/[^\d]/g, "");
    if (n.length < 4) return n;
    if (n.length < 7) return `${n.slice(0, 3)}-${n.slice(3)}`;
    return `${n.slice(0, 3)}-${n.slice(3, 6)}-${n.slice(6, 10)}`;
  };

  const getDisplayName = (performer) =>
    [performer?.name, performer?.lastName].filter(Boolean).join(" ").trim() || "Unnamed User";

  const getInitials = (performer) => {
    const nameParts = getDisplayName(performer).split(" ").filter(Boolean);
    return nameParts.slice(0, 2).map((part) => part.charAt(0).toUpperCase()).join("");
  };

  const handlePageChange = (page) => {
    const { startIndex: start, endIndex: end } = calculateIndex(page, startIndex, endIndex);
    setCurrentPage(page);
    setStartIndex(start);
    setEndIndex(end);
    getPagedData(performerList, page, pageSize);
  };

  const handlePageSizeChanged = ({ currentTarget }) => {
    const newSize = Number(currentTarget.value);
    setPageSize(newSize);
    setCurrentPage(1);
    setStartIndex(0);
    setEndIndex(5);
    getPagedData(performerList, 1, newSize);
  };

  const handleSelectUser = (item) => {
    if (selectedUserId === item.id) {
      handleResetSelection();
    } else {
      setSelectedUserId(item.id);
      setSelectedObj(item);
    }
  };

  const handleResetSelection = () => {
    setSelectedUserId(0);
    setSelectedObj(null);
  };

  const handlePermissionShowHide = () => {
    if (currentUser?.roleid) {
      dispatch(loadRolePerformers(currentUser.roleid, true));
    }
    handleResetSelection();
    setSelectedKey("home");
  };

  const handlePermissionShowHide2 = () => {
    if (currentUser?.roleid) {
      dispatch(loadRolePerformers(currentUser.roleid, true));
    }
    setSelectedKey("home");
  };

  const handleTabSelect = (tab) => setSelectedKey(tab);

  const handleAddUser = () => {
    handleResetSelection();
    setSelectedKey("addedituser");
  };

  const handleRefresh = () => {
    if (currentUser?.roleid) {
      dispatch(loadRolePerformers(currentUser.roleid, true));
    }
  };

  const item = currentUser || "";
  const activeCount = performerList.filter(p => p.status).length;
  const inactiveCount = performerList.length - activeCount;

  return (
    <React.Fragment>
      <style>{`
        /* ── Animations ── */
        @keyframes searchSlideDown {
          from { opacity: 0; transform: translateY(-8px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        @keyframes shimmer {
          0%   { background-position: -600px 0; }
          100% { background-position:  600px 0; }
        }
        @keyframes loadingBar {
          0%   { width: 0%;   opacity: 1; }
          70%  { width: 85%;  opacity: 1; }
          100% { width: 100%; opacity: 0; }
        }
        @keyframes rowFadeIn {
          from { opacity: 0; transform: translateY(4px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        @keyframes tabFadeIn {
          from { opacity: 0; transform: translateY(6px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        @keyframes emptyFadeUp {
          from { opacity: 0; transform: translateY(18px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        @keyframes emptyFloat {
          0%, 100% { transform: translateY(0px);  }
          50%       { transform: translateY(-6px); }
        }
        @keyframes emptyGlow {
          0%, 100% { box-shadow: 0 0 0 0 rgba(37,99,235,0.18), 0 0 0 8px rgba(37,99,235,0.06); }
          50%       { box-shadow: 0 0 0 6px rgba(37,99,235,0.12), 0 0 0 14px rgba(37,99,235,0.04); }
        }
        @keyframes emptyOrbit {
          from { transform: rotate(0deg) translateX(38px) rotate(0deg); }
          to   { transform: rotate(360deg) translateX(38px) rotate(-360deg); }
        }
        @keyframes emptyOrbit2 {
          from { transform: rotate(180deg) translateX(52px) rotate(-180deg); }
          to   { transform: rotate(540deg) translateX(52px) rotate(-540deg); }
        }
        @keyframes emptySparkle {
          0%,100% { opacity:0; transform: scale(0.5) rotate(0deg);   }
          50%      { opacity:1; transform: scale(1)   rotate(180deg); }
        }

        /* ── Loading Bar ── */
        .mwp-loading-bar {
          position: absolute; top: 0; left: 0; right: 0;
          height: 3px;
          background: linear-gradient(90deg, #171717, #737373, #171717);
          background-size: 200% 100%;
          animation: loadingBar 1.6s ease-in-out infinite;
          z-index: 10;
        }

        /* ── Skeleton Rows ── */
        .skeleton-cell {
          display: block; height: 13px; border-radius: 6px;
          background: linear-gradient(90deg, #f1f5f9 25%, #e2e8f0 50%, #f1f5f9 75%);
          background-size: 600px 100%;
          animation: shimmer 1.4s ease-in-out infinite;
        }
        .skeleton-cell.sk-short  { width: 40%; }
        .skeleton-cell.sk-medium { width: 65%; }
        .skeleton-cell.sk-long   { width: 85%; }
        .skeleton-cell.sk-full   { width: 92%; }
        .skeleton-row td { padding: 14px 16px !important; }

        /* ── Main Card ── */
        .wf-main-card {
          background: rgba(255, 255, 255, 0.97) !important;
          border: 1px solid rgba(226, 232, 240, 0.8) !important;
          box-shadow: 0 4px 24px -4px rgba(15, 23, 42, 0.06), 0 1px 4px -1px rgba(15, 23, 42, 0.04) !important;
          border-radius: 0 !important;
          transition: all 0.3s ease !important;
          overflow: hidden !important;
          position: relative !important;
          height: auto !important;
          min-height: 420px !important;
          display: flex !important;
          flex-direction: column !important;
          margin-bottom: 0 !important;
          font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif !important;
        }

        /* ── Card Header Section (Integrated Style) ── */
        .wf-header-section {
          display: flex; align-items: flex-start; justify-content: space-between;
          flex-wrap: wrap; gap: 18px; padding: 22px 24px 18px;
          background: #ffffff;
          border-bottom: 1px solid #f1f5f9;
          position: relative;
          overflow: hidden;
        }
        .wf-header-left { display: flex; align-items: flex-start; gap: 14px; flex: 1; min-width: 260px; }
        .wf-header-right {
          display: flex;
          align-items: flex-start;
          gap: 8px;
          flex-wrap: wrap;
        }
        .wf-icon-box {
          width: 44px; height: 44px; border-radius: 0;
          background: #f5f5f5; border: 1px solid #d4d4d4;
          display: flex; align-items: center; justify-content: center;
          color: #64748b; font-size: 18px; flex-shrink: 0;
          box-shadow: none;
        }
        .wf-title-block { min-width: 0; }
        .wf-kicker {
          display: inline-flex; align-items: center; gap: 6px;
          margin: 0 0 5px; color: #64748b; font-size: 12px;
          font-weight: 600; letter-spacing: 0.08em; text-transform: uppercase;
        }
        .wf-title { font-size: 18px; font-weight: 600; color: #0f172a; margin: 0; line-height: 1.2; }
        .wf-subtitle { font-size: 14px; font-weight: 400; color: #64748b; margin: 6px 0 0; }
        .wf-header-meta { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; margin-top: 12px; }
        .wf-meta-pill {
          display: inline-flex; align-items: center; gap: 6px;
          padding: 4px 10px; border-radius: 0; background: transparent !important;
          border: 1px solid #d4d4d4; color: #64748b; font-size: 12px; font-weight: 500;
        }
        .wf-meta-pill i { color: #64748b; font-size: 12px; }
        .wf-meta-pill.is-active i { color: #047857; }
        .wf-meta-pill.is-inactive i { color: #b91c1c; }

        /* ── Table Toolbar ── */
        .wf-toolbar {
          display: flex; align-items: center; justify-content: space-between;
          padding: 12px 20px; background: #ffffff; border-bottom: 1px solid #f1f5f9;
        }

        /* ── Search Panel ── */
        .search-panel-collapse {
          background: #ffffff !important;
          border: 1px solid rgba(203,213,225,0.7) !important;
          border-radius: 0 !important;
          padding: 0 !important;
          box-shadow: none !important;
          animation: searchSlideDown 0.3s cubic-bezier(0.16,1,0.3,1) both;
          margin-top: 12px !important;
          margin-bottom: 8px !important;
          overflow: hidden !important;
        }
        .sp-header {
          display: flex; align-items: center; justify-content: space-between;
          padding: 14px 20px 12px;
          border-bottom: 1px solid rgba(226,232,240,0.8);
          background: #ffffff !important;
        }
        .sp-header-title {
          display: flex; align-items: center; gap: 8px;
          font-size: 14px; font-weight: 500; color: #1e293b; letter-spacing: 0.1px;
        }
        .sp-header-title i { color: #64748b; font-size: 14px; }
        .sp-header-badge {
          display: inline-flex; align-items: center; gap: 4px;
          background: transparent !important; border: 1px solid rgba(37,99,235,0.15);
          color: #1d4ed8; border-radius: 0; padding: 3px 10px;
          font-size: 12px; font-weight: 600; letter-spacing: 0.3px; text-transform: uppercase;
        }
        .search-panel-collapse input,
        .search-panel-collapse textarea,
        .search-panel-collapse select { font-weight: 400 !important; }
        .search-panel-collapse input::placeholder,
        .search-panel-collapse textarea::placeholder,
        .search-panel-collapse [class*="-placeholder"] {
          font-weight: 400 !important;
          color: #94a3b8 !important;
        }
        .sp-body { padding: 18px 20px 14px; }
        .sp-footer {
          display: flex; align-items: center; justify-content: center; gap: 8px;
          padding: 12px 20px;
          border-top: 1px solid rgba(226,232,240,0.7);
          background: #ffffff;
        }
        .wf-control-label {
          font-size: 12px !important; font-weight: 600 !important; color: #64748b !important;
          text-transform: uppercase !important; letter-spacing: 0.7px !important;
          margin-bottom: 7px !important; display: flex !important; align-items: center !important; gap: 5px !important;
        }
        .wf-control-label i { color: #94a3b8; font-size: 12px; }
        .wf-input-wrap { position: relative; }
        .wf-input-icon {
          position: absolute; left: 12px; top: 50%; transform: translateY(-50%);
          color: #94a3b8; font-size: 14px; pointer-events: none; transition: color 0.2s ease; z-index: 1;
        }
        .wf-input-wrap:focus-within .wf-input-icon { color: #2563eb; }
        .wf-input {
          border-radius: 0 !important; border: 1.5px solid #e2e8f0 !important;
          padding: 9px 14px 9px 36px !important; font-size: 14px !important; font-weight: 400 !important;
          color: #1e293b !important; background: #ffffff !important;
          transition: all 0.2s cubic-bezier(0.4,0,0.2,1) !important;
          height: auto !important; width: 100% !important;
          box-shadow: 0 1px 3px 0 rgba(0,0,0,0.03) !important;
        }
        .wf-filter-input-no-icon .wf-input { padding-left: 14px !important; }
        .wf-input::placeholder { color: #94a3b8 !important; font-weight: 400 !important; }
        .wf-input:hover { border-color: #94a3b8 !important; box-shadow: 0 2px 6px -1px rgba(0,0,0,0.06) !important; }
        .wf-input:focus {
          border-color: #2563eb !important;
          box-shadow: 0 0 0 4px rgba(37,99,235,0.1), 0 2px 6px -1px rgba(37,99,235,0.08) !important;
          outline: none !important; background: #fafbff !important;
        }

        /* ── Buttons — matched to WorkflowUser / TopMenu ── */
        .btn-search-trigger {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          gap: 8px !important;
          background: #ffffff !important;
          border: 1px solid #cbd5e1 !important;
          padding: 7px 14px !important;
          border-radius: 0 !important;
          font-size: 14px !important;
          font-weight: 500 !important;
          letter-spacing: 0.01em !important;
          font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif !important;
          color: #1e293b !important;
          cursor: pointer !important;
          transition: all 0.2s ease !important;
          box-shadow: 0 2px 5px rgba(15, 23, 42, 0.08) !important;
          min-height: unset !important;
          height: auto !important;
          line-height: 1.25 !important;
        }
        .btn-search-trigger:hover {
          background: #f8fafc !important;
          color: #0f172a !important;
          border-color: #94a3b8 !important;
          box-shadow: 0 3px 8px rgba(15, 23, 42, 0.12) !important;
        }
        .btn-action-search {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          gap: 8px !important;
          background: #ffffff !important;
          border: 1px solid #cbd5e1 !important;
          padding: 7px 14px !important;
          border-radius: 0 !important;
          font-size: 14px !important;
          font-weight: 500 !important;
          letter-spacing: 0.01em !important;
          font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif !important;
          color: #1e293b !important;
          cursor: pointer !important;
          transition: all 0.2s ease !important;
          outline: none !important;
          box-shadow: 0 2px 5px rgba(15, 23, 42, 0.08) !important;
          min-height: unset !important;
          line-height: 1.25 !important;
        }
        .btn-action-search:hover {
          background: #f8fafc !important;
          color: #0f172a !important;
          border-color: #94a3b8 !important;
          transform: none !important;
          box-shadow: 0 3px 8px rgba(15, 23, 42, 0.12) !important;
        }
        .btn-action-search.btn-primary-search {
          background: #2563eb !important;
          color: #ffffff !important;
          border-color: #2563eb !important;
          box-shadow: 0 2px 5px rgba(37, 99, 235, 0.2) !important;
        }
        .btn-action-search.btn-primary-search:hover {
          background: #1d4ed8 !important;
          color: #ffffff !important;
          transform: none !important;
          box-shadow: 0 3px 8px rgba(37, 99, 235, 0.28) !important;
        }
        .btn-action-search:disabled {
          background: #ffffff !important;
          color: #94a3b8 !important;
          border-color: #cbd5e1 !important;
          cursor: not-allowed !important;
          transform: none !important;
          box-shadow: 0 2px 5px rgba(15, 23, 42, 0.04) !important;
          opacity: 1 !important;
        }
        .btn-action-search.btn-primary-search:disabled {
          background: #e2e8f0 !important;
          color: #94a3b8 !important;
          border-color: #cbd5e1 !important;
          cursor: not-allowed !important;
          transform: none !important;
          box-shadow: none !important;
          opacity: 1 !important;
        }
        .btn-action-search.btn-danger-search {
          background: #ffffff !important;
          color: #991b1b !important;
          border: 1px solid #fca5a5 !important;
          box-shadow: 0 2px 5px rgba(220, 38, 38, 0.12) !important;
        }
        .btn-action-search.btn-danger-search:hover {
          background: #fff5f5 !important;
          color: #7f1d1d !important;
          border-color: #f87171 !important;
          transform: none !important;
          box-shadow: 0 3px 8px rgba(220, 38, 38, 0.16) !important;
        }

        /* ── Tabs ── */
        .wf-tab-bar {
          display: flex; align-items: stretch; gap: 4px;
          border-bottom: 2px solid #e5e5e5; margin-bottom: 0;
          padding: 8px 0 0; position: relative;
        }
        .wf-tab-bar *,
        .wf-tab-btn,
        .wf-tab-btn *,
        .wf-tab-btn:hover,
        .wf-tab-btn.active,
        .wf-tab-btn.active *,
        .wf-tab-badge {
          border-radius: 0 !important;
        }
        .wf-tab-btn {
          position: relative; display: inline-flex; align-items: center; gap: 7px;
          border: none; background: transparent; padding: 9px 16px 11px;
          font-size: 14px; font-weight: 500; color: #1e293b;
          font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
          cursor: pointer; border-radius: 0 !important;
          transition: color 0.2s ease, background 0.2s ease; outline: none; white-space: nowrap;
        }
        .wf-tab-btn i { font-size: 14px; color: currentColor; transition: color 0.2s ease; }
        .wf-tab-btn:hover { color: #0f172a; background: #f5f5f5; border-radius: 0 !important; }
        .wf-tab-btn:focus, .wf-tab-btn:focus-visible, .wf-tab-btn:active {
          outline: none !important; box-shadow: none !important; border-color: transparent !important;
        }
        .wf-tab-btn.active,
        .wf-tab-btn.active:hover,
        .wf-tab-btn.active:focus { color: #ffffff !important; font-weight: 500 !important; background: #171717 !important; border-radius: 0 !important; }
        .wf-tab-btn.active i { color: #ffffff !important; }
        .wf-tab-btn::after {
          content: ""; position: absolute; bottom: -2px; left: 0; right: 0;
          height: 2px; background: #171717; border-radius: 0 !important;
          transform: scaleX(0); transition: transform 0.25s cubic-bezier(0.4,0,0.2,1);
        }
        .wf-tab-btn.active::after { transform: scaleX(0); }
        .wf-tab-badge {
          display: inline-flex; align-items: center; justify-content: center;
          min-width: 20px; height: 20px; padding: 0 6px; border-radius: 0 !important;
          font-size: 12px; font-weight: 600; background: #f1f5f9; color: #1e293b;
          border: 1px solid #e2e8f0; transition: all 0.2s ease; line-height: 1;
        }
        .wf-tab-btn.active .wf-tab-badge {
          background: #ffffff !important; color: #171717 !important; border-color: #ffffff !important; border-radius: 0 !important;
        }

        .wf-tab-panel {
          animation: tabFadeIn 0.28s cubic-bezier(0.16, 1, 0.3, 1) both;
          flex: 1 1 auto;
          min-height: auto;
          overflow-y: visible;
          overflow-x: hidden;
          padding-right: 4px;
          scrollbar-width: thin;
          scrollbar-color: #94a3b8 #f1f5f9;
        }

        body.workflow-user-card-scroll #layout-scroll-wrapper {
          overflow-y: auto !important;
        }

        body.workflow-user-card-scroll .modern-breadcrumb-container {
          margin-bottom: 10px !important;
        }

        .wf-main-card > .card-body:not(.wf-tabs-container) {
          flex: 1 1 auto !important;
          min-height: auto !important;
          overflow-y: visible !important;
          overflow-x: hidden !important;
          scrollbar-width: thin;
          scrollbar-color: #94a3b8 #f1f5f9;
        }

        .wf-tabs-container {
          display: flex;
          flex: 1 1 auto !important;
          flex-direction: column;
          min-height: auto !important;
          overflow: visible !important;
        }

        .wf-tab-panel::-webkit-scrollbar,
        .wf-main-card > .card-body:not(.wf-tabs-container)::-webkit-scrollbar {
          width: 8px;
          height: 8px;
        }

        .wf-tab-panel::-webkit-scrollbar-track,
        .wf-main-card > .card-body:not(.wf-tabs-container)::-webkit-scrollbar-track {
          background: #f1f5f9;
          border-radius: 999px;
        }

        .wf-tab-panel::-webkit-scrollbar-thumb,
        .wf-main-card > .card-body:not(.wf-tabs-container)::-webkit-scrollbar-thumb {
          background: linear-gradient(180deg, #cbd5e1 0%, #94a3b8 100%);
          border-radius: 999px;
          border: 2px solid #f1f5f9;
        }

        .wf-tab-panel::-webkit-scrollbar-thumb:hover,
        .wf-main-card > .card-body:not(.wf-tabs-container)::-webkit-scrollbar-thumb:hover {
          background: linear-gradient(180deg, #94a3b8 0%, #64748b 100%);
        }

        /* ── Selected User Context Card ── */
        .wf-assign-card {
          display: flex; align-items: center; justify-content: space-between;
          gap: 20px; padding: 18px 22px;
          background: #ffffff;
          border: 1px solid #d4d4d4; border-radius: 0;
          margin: 12px 0; flex-wrap: wrap;
          animation: tabFadeIn 0.3s ease both;
        }
        .wf-assign-info { display: flex; align-items: center; gap: 14px; }
        .wf-assign-avatar {
          width: 44px; height: 44px; border-radius: 0;
          background: #171717;
          display: flex; align-items: center; justify-content: center;
          color: white; font-size: 16px; font-weight: 600; flex-shrink: 0;
        }
        .wf-assign-meta strong {
          display: block; font-size: 14px; font-weight: 600; color: #1e293b; margin-bottom: 3px;
        }
        .wf-assign-meta span { font-size: 12px; color: #64748b; font-weight: 400; }
        .wf-assign-actions { display: flex; gap: 8px; align-items: center; flex-wrap: wrap; }
        .wf-assign-actions .btn-action-search {
          height: auto !important;
          box-sizing: border-box !important;
          justify-content: center !important;
        }
        /* ── Table ── */
        .wf-table-scroll table,
        .wf-table-scroll .wf-table {
          width: 100% !important;
          border-collapse: collapse !important;
          border: 1px solid #cbd5e1 !important;
        }
        .wf-table-scroll {
          overflow: auto !important; scrollbar-width: thin; scrollbar-color: #94a3b8 #f1f5f9;
          border-radius: 0;
          border: none !important;
        }
        .wf-table-scroll::-webkit-scrollbar { width: 8px; height: 8px; }
        .wf-table-scroll::-webkit-scrollbar-track { background: #f1f5f9; border-radius: 999px; }
        .wf-table-scroll::-webkit-scrollbar-thumb {
          background: linear-gradient(180deg, #cbd5e1 0%, #94a3b8 100%);
          border-radius: 999px; border: 2px solid #f1f5f9;
        }
        .wf-table-scroll::-webkit-scrollbar-thumb:hover {
          background: linear-gradient(180deg, #94a3b8 0%, #64748b 100%);
        }
        .wf-thead {
          background: #f8fafc !important;
          position: sticky !important; top: 0 !important; z-index: 2 !important;
        }
        .wf-thead th {
          font-size: 12px !important; font-weight: 600 !important; color: #64748b !important;
          text-transform: uppercase !important; letter-spacing: 0.6px !important;
          padding: 13px 16px !important; border-bottom: 2px solid #e2e8f0 !important;
          border-top: none !important; border-left: none !important; border-right: none !important; white-space: nowrap !important;
        }
        .wf-table-row {
          cursor: pointer !important;
          transition: background 0.15s ease, box-shadow 0.15s ease, transform 0.1s ease !important;
          animation: rowFadeIn 0.25s ease both !important;
        }
        .wf-table-row:hover {
          background: #f5f5f5 !important;
          box-shadow: inset 3px 0 0 0 #171717 !important;
        }
        .wf-table-row:hover td { color: #1e293b !important; }
        .wf-table-row:active { transform: scaleY(0.98) !important; }
        .wf-table-row.selected-row {
          background: #f5f5f5 !important;
          box-shadow: inset 4px 0 0 0 #171717 !important;
        }
        .wf-table-row.selected-row:hover {
          background: #eeeeee !important;
        }
        .wf-table td {
          padding: 13px 16px !important; font-size: 14px !important; font-weight: 400 !important;
          color: #1e293b !important;
          border-bottom: 1px solid #f1f5f9 !important; border-top: none !important;
          border-left: none !important; border-right: none !important; vertical-align: middle !important;
          transition: color 0.15s ease !important;
        }
        .wf-table-row td,
        .wf-table-row td * {
          font-size: 14px !important;
        }
        .wf-name-main {
          font-size: 14px !important;
          font-weight: 500 !important;
          color: #1e293b !important;
        }
        .wf-name-title,
        .wf-data-line,
        .wf-empty-value {
          font-weight: 400 !important;
        }
        .wf-name-title,
        .wf-name-meta .wf-empty-value,
        .wf-empty-value,
        .wf-id-cell {
          font-size: 12px !important;
        }
        .wf-data-line i,
        .wf-name-avatar {
          font-size: 12px !important;
        }
        .badge-capsule {
          font-size: 12px !important;
          font-weight: 500 !important;
        }
        .wf-table tbody tr:last-child td,
        .wf-table-row.selected-row:last-child td,
        .wf-table tbody tr:last-child.selected-row td { border-bottom: none !important; }
        .wf-id-cell {
          display: inline-flex; align-items: center; gap: 6px;
          min-width: 64px; padding: 4px 8px; border-radius: 0;
          background: transparent !important; border: 1px solid #e2e8f0;
          font-size: 12px; font-weight: 500; color: #64748b;
        }
        .wf-id-cell.is-selected {
          background: #f5f5f5; border-color: #d4d4d4; color: #1e293b;
        }
        .wf-name-cell { display: flex; align-items: center; gap: 10px; min-width: 190px; }
        .wf-name-avatar {
          width: 34px; height: 34px; border-radius: 0;
          display: inline-flex; align-items: center; justify-content: center;
          background: #f5f5f5;
          border: 1px solid #d4d4d4;
          color: #1e293b; font-size: 12px; font-weight: 600; flex-shrink: 0;
        }
        .wf-name-meta { display: flex; flex-direction: column; gap: 2px; min-width: 0; }
        .wf-name-main { font-size: 14px; font-weight: 500; color: #1e293b; text-transform: uppercase; }
        .wf-name-title,
        .wf-name-meta .wf-empty-value { font-size: 12px; color: #64748b; font-weight: 400; }
        .wf-data-line {
          display: inline-flex; align-items: center; gap: 7px;
          color: #64748b; font-size: 14px; font-weight: 400; white-space: nowrap;
        }
        .wf-data-line i { color: #94a3b8; font-size: 12px; }
        .wf-email-line {
          max-width: 250px; overflow: hidden; text-overflow: ellipsis;
        }
        .wf-azure-email-cell,
        .wf-azure-email-cell * { font-weight: 400 !important; color: #64748b !important; }
        .wf-empty-value { color: #94a3b8; font-size: 12px; font-weight: 400; }

        /* ── Login Type Badges ── */
        .badge-capsule {
          display: inline-flex !important; align-items: center !important; justify-content: center !important;
          padding: 4px 8px !important; border-radius: 0 !important;
          width: 78px !important; min-width: 78px !important; text-align: center !important;
          font-size: 12px !important; font-weight: 500 !important; line-height: 1 !important;
          box-sizing: border-box !important;
        }
        .badge-system { background: #f1f5f9 !important; color: #475569 !important; border: 1px solid #cbd5e1 !important; }
        .badge-azure { background: rgba(37,99,235,0.08) !important; color: #1d4ed8 !important; border: 1px solid rgba(37,99,235,0.15) !important; }
        .badge-active { background: rgba(16,185,129,0.08) !important; color: #047857 !important; border: 1px solid rgba(16,185,129,0.15) !important; }
        .badge-inactive { background: rgba(239,68,68,0.08) !important; color: #b91c1c !important; border: 1px solid rgba(239,68,68,0.15) !important; }
        .wf-login-type-cell,
        .wf-login-type-cell *,
        .wf-status-cell,
        .wf-status-cell * { font-weight: 400 !important; }
        .wf-login-type-cell .badge-azure {
          background: rgba(37, 99, 235, 0.08) !important;
          border-color: rgba(37, 99, 235, 0.15) !important;
          color: #1d4ed8 !important;
        }
        .wf-login-type-cell .badge-system {
          background: #f1f5f9 !important;
          border-color: #cbd5e1 !important;
          color: #475569 !important;
        }
        .wf-status-cell .badge-active {
          background: rgba(16, 185, 129, 0.08) !important;
          border-color: rgba(16, 185, 129, 0.15) !important;
          color: #047857 !important;
        }
        .wf-status-cell .badge-inactive {
          background: rgba(239, 68, 68, 0.08) !important;
          border-color: rgba(239, 68, 68, 0.15) !important;
          color: #b91c1c !important;
        }
        .badge-unrestricted { background: #f1f5f9 !important; color: #475569 !important; border: 1px solid #cbd5e1 !important; }
        .badge-count { background: rgba(37,99,235,0.08) !important; color: #1d4ed8 !important; border: 1px solid rgba(37,99,235,0.15) !important; }

        /* ── Empty State (premium animated) ── */
        .wf-table-empty {
          position: relative; display: flex; flex-direction: column;
          align-items: center; justify-content: center;
          padding: 56px 24px 48px; text-align: center; overflow: hidden;
          background: #f8faff;
          border-radius: 0; margin: 12px;
          border: 1.5px solid rgba(37,99,235,0.1);
          animation: emptyFadeUp 0.45s cubic-bezier(0.16,1,0.3,1) both;
        }
        .wf-table-empty::before {
          content: ''; position: absolute;
          width: 260px; height: 260px; border-radius: 50%;
          background: radial-gradient(circle, rgba(37,99,235,0.07) 0%, transparent 70%);
          top: -60px; left: -60px; pointer-events: none;
        }
        .wf-table-empty::after {
          content: ''; position: absolute;
          width: 200px; height: 200px; border-radius: 50%;
          background: radial-gradient(circle, rgba(124,58,237,0.06) 0%, transparent 70%);
          bottom: -40px; right: -40px; pointer-events: none;
        }
        .wf-te-dots {
          position: absolute; inset: 0;
          background-image: radial-gradient(circle, rgba(37,99,235,0.12) 1px, transparent 1px);
          background-size: 22px 22px; opacity: 0.35; pointer-events: none;
        }
        .wf-te-orbit-wrap {
          position: relative; width: 110px; height: 110px;
          display: flex; align-items: center; justify-content: center;
          margin-bottom: 24px; z-index: 1;
        }
        .wf-te-ring {
          position: absolute; inset: -6px; border-radius: 50%;
          border: 1.5px solid rgba(37,99,235,0.15);
          animation: emptyGlow 2.4s ease-in-out infinite;
        }
        .wf-te-ring2 {
          position: absolute; inset: -18px; border-radius: 50%;
          border: 1px dashed rgba(37,99,235,0.1);
          animation: emptyGlow 2.4s ease-in-out 0.8s infinite;
        }
        .wf-te-orb {
          position: absolute; width: 8px; height: 8px; border-radius: 50%;
          background: linear-gradient(135deg,#2563eb,#7c3aed);
          top: 50%; left: 50%; margin: -4px 0 0 -4px;
          animation: emptyOrbit 3.5s linear infinite;
          box-shadow: 0 2px 6px rgba(37,99,235,0.35);
        }
        .wf-te-orb2 {
          position: absolute; width: 6px; height: 6px; border-radius: 50%;
          background: linear-gradient(135deg,#7c3aed,#ec4899);
          top: 50%; left: 50%; margin: -3px 0 0 -3px;
          animation: emptyOrbit2 5s linear infinite;
          box-shadow: 0 2px 5px rgba(124,58,237,0.3);
        }
        .wf-te-icon {
          width: 72px; height: 72px; border-radius: 50%;
          background: linear-gradient(135deg, #eff6ff 0%, #f5f3ff 100%);
          border: 2px solid rgba(37,99,235,0.15);
          display: flex; align-items: center; justify-content: center;
          font-size: 28px; color: #2563eb; position: relative; z-index: 2;
          animation: emptyFloat 3s ease-in-out infinite;
          box-shadow: 0 8px 24px rgba(37,99,235,0.12), 0 2px 8px rgba(0,0,0,0.04);
        }
        .wf-te-spark {
          position: absolute; width: 6px; height: 6px; border-radius: 50%; z-index: 1;
        }
        .wf-te-spark:nth-child(1) { top:8px; right:12px; background:#7c3aed; animation:emptySparkle 2.2s 0.0s infinite; }
        .wf-te-spark:nth-child(2) { bottom:8px; left:14px; background:#2563eb; animation:emptySparkle 2.2s 0.7s infinite; }
        .wf-te-spark:nth-child(3) { top:22px; left:6px; background:#ec4899; animation:emptySparkle 2.2s 1.4s infinite; width:4px; height:4px; }
        .wf-te-label {
          font-size: 12px; font-weight: 600; letter-spacing: 0.08em; text-transform: uppercase;
          color: #2563eb; background: rgba(37,99,235,0.07); border: 1px solid rgba(37,99,235,0.12);
          border-radius: 0; padding: 3px 12px; margin-bottom: 10px; z-index: 1;
        }
        .wf-te-title {
          font-size: 18px; font-weight: 600;
          background: linear-gradient(135deg, #1e293b 0%, #334155 100%);
          -webkit-background-clip: text; -webkit-text-fill-color: transparent;
          background-clip: text; margin: 0 0 10px 0; line-height: 1.3; z-index: 1;
        }
        .wf-te-desc {
          font-size: 14px; font-weight: 400; color: #64748b; margin: 0 0 22px 0;
          max-width: 340px; line-height: 1.65; z-index: 1;
        }
        .wf-te-cta {
          display: inline-flex !important; align-items: center !important; gap: 7px !important;
          background: linear-gradient(135deg, #2563eb 0%, #4f46e5 100%) !important;
          color: #ffffff !important; border: none !important;
          padding: 10px 22px !important; border-radius: 0 !important; background: #2563eb !important;
          font-size: 14px !important; font-weight: 500 !important; cursor: pointer !important;
          transition: all 0.25s ease !important; box-shadow: 0 4px 14px rgba(37,99,235,0.3) !important;
          z-index: 1; position: relative;
        }
        .wf-te-cta:hover {
          transform: translateY(-2px) !important;
          box-shadow: 0 8px 20px rgba(37,99,235,0.4) !important;
          background: linear-gradient(135deg, #1d4ed8 0%, #4338ca 100%) !important;
        }

        /* ── Table Footer ── */
        .wf-table-footer {
          display: flex; align-items: center; justify-content: space-between;
          flex-wrap: wrap; gap: 10px; margin-top: 12px;
        }
        .wf-results-label {
          font-size: 14px; color: #64748b; font-weight: 400;
        }

        /* ── Simple Empty State (non-table) ── */
        .wf-empty-state {
          display: flex; flex-direction: column; align-items: center; justify-content: center;
          padding: 40px 24px; text-align: center; gap: 12px;
          animation: tabFadeIn 0.3s ease both;
        }
        .wf-empty-icon {
          width: 52px; height: 52px; border-radius: 0;
          display: flex; align-items: center; justify-content: center; font-size: 22px;
          background: #171717;
          border: 1px solid #171717; color: #ffffff; margin-bottom: 4px;
        }
        .wf-empty-title { font-size: 15px; font-weight: 600; color: #1e293b; margin: 0; }
        .wf-empty-desc { font-size: 14px; font-weight: 400; color: #64748b; margin: 0 auto; line-height: 1.6; }
      `}</style>

      <div className="col-md-12">
        <div className="card mb-4 shadow-none wf-main-card manage-workflow-performer-page">

          {/* ── Premium Integrated Header ── */}
          <div className="wf-header-section">
            {isLoading && <div className="mwp-loading-bar" />}
            <div className="wf-header-left">
              <div className="wf-icon-box">
                <i className="fa fa-id-card-o" aria-hidden="true" />
              </div>
              <div className="wf-title-block">
                <h2 className="wf-title">
                  {item.rolename || "Workflow Role Users"}
                  {item.roleid ? ` (Role ID: ${item.roleid})` : ""}
                </h2>
                <div className="wf-header-meta">
                  <span className="wf-meta-pill is-active">
                    <i className="fa fa-check-circle" aria-hidden="true" />
                    {activeCount} Active
                  </span>
                  <span className="wf-meta-pill is-inactive">
                    <i className="fa fa-times-circle" aria-hidden="true" />
                    {inactiveCount} Inactive
                  </span>
                  <span className="wf-meta-pill">
                    <i className="fa fa-users" aria-hidden="true" />
                    {rowsCount} Users
                  </span>
                </div>
              </div>
            </div>
            <div className="wf-header-right">
              <button
                className="btn-search-trigger"
                onClick={handleAddUser}
              >
                <i className="fa fa-user-plus" aria-hidden="true" /> Add User
              </button>
              <button
                className="btn-search-trigger"
                data-toggle="collapse"
                data-target="#mwpSearchPanel"
              >
                <i className="fa fa-filter" aria-hidden="true" /> Filters
              </button>
              <button
                className="btn-search-trigger"
                onClick={handleRefresh}
                disabled={isLoading}
                title="Reload users"
              >
                <i className="fa fa-refresh" aria-hidden="true" /> Refresh
              </button>
              <button className="btn-search-trigger" onClick={() => navigate("/WorkflowUser")}>
                <i className="fa fa-arrow-left" aria-hidden="true" /> Back
              </button>
            </div>
          </div>

          {/* ── Toolbar ── */}
          <div className="wf-toolbar">
            <div className="d-flex align-items-center" style={{ gap: '14px' }}>
              <PageSizeOptions pageSize={pageSize} onChange={handlePageSizeChanged} />
            </div>
            <div className="d-flex align-items-center" style={{ gap: '8px' }}>
            </div>
          </div>

          {/* ── Search Panel ── */}
          <div className="px-3">
            <div className="collapse" id="mwpSearchPanel">
              <div className="search-panel-collapse">
                <div className="sp-header">
                  <span className="sp-header-title">
                    <i className="fa fa-sliders" />
                    Filter Users
                  </span>
                </div>
                <div className="sp-body">
                  <div className="row">
                    <div className="col-md-2 form-group mb-3">
                      <label htmlFor="mwpFilterId" className="wf-control-label">
                        ID
                      </label>
                      <div className="wf-input-wrap wf-filter-input-no-icon">
                        <input
                          type="text"
                          id="mwpFilterId"
                          className="form-control wf-input"
                          placeholder="e.g. 42"
                          value={performerId}
                          onChange={({ currentTarget }) => setPerformerId(currentTarget.value)}
                          onKeyDown={e => e.key === "Enter" && handleFilter()}
                          autoComplete="off"
                        />
                      </div>
                    </div>
                    <div className="col-md-5 form-group mb-3">
                      <label htmlFor="mwpFilterName" className="wf-control-label">
                        Name
                      </label>
                      <div className="wf-input-wrap wf-filter-input-no-icon">
                        <input
                          type="text"
                          id="mwpFilterName"
                          className="form-control wf-input"
                          placeholder="Search user name…"
                          value={performerName}
                          onChange={({ currentTarget }) => setPerformerName(currentTarget.value)}
                          onKeyDown={e => e.key === "Enter" && handleFilter()}
                          autoComplete="off"
                        />
                      </div>
                    </div>
                    <div className="col-md-5 form-group mb-3">
                      <label htmlFor="mwpFilterMobile" className="wf-control-label">
                        Mobile No.
                      </label>
                      <div className="wf-input-wrap wf-filter-input-no-icon">
                        <input
                          type="text"
                          id="mwpFilterMobile"
                          className="form-control wf-input"
                          placeholder="Mobile number…"
                          value={formatPhoneNumber(mobile)}
                          onChange={({ currentTarget }) => setMobile(currentTarget.value.replace(/[^\d]/g, ""))}
                          onKeyDown={e => e.key === "Enter" && handleFilter()}
                          autoComplete="off"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="sp-footer">
                  <button
                    className="btn-action-search btn-danger-search"
                    data-toggle="collapse"
                    data-target="#mwpSearchPanel"
                    onClick={handleFilterCancel}
                  >
                    <i className="fa fa-times" aria-hidden="true" /> Clear &amp; Close
                  </button>
                  <button className="btn-action-search" onClick={handleFilterCancel}>
                    <i className="fa fa-refresh" aria-hidden="true" /> Reset
                  </button>
                  <button
                    className="btn-action-search btn-primary-search"
                    onClick={handleFilter}
                    disabled={isFiltering || (!performerId.trim() && !performerName.trim() && !mobile.trim())}
                  >
                    {isFiltering ? (
                      <>
                        <i className="fa fa-circle-o-notch fa-spin" aria-hidden="true" /> Applying...
                      </>
                    ) : (
                      <>
                        <i className="fa fa-search" aria-hidden="true" /> Apply Filters
                      </>
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* ── Tabs & Content ── */}
          <div className="card-body px-3 pt-0 pb-3 wf-tabs-container">

            {/* Tab Bar */}
            <div className="wf-tab-bar">
              <button
                className={`wf-tab-btn${selectedKey === "home" ? " active" : ""}`}
                onClick={() => handleTabSelect("home")}
              >
                <i className="fa fa-list-alt" />
                Users
                <span className="wf-tab-badge">{rowsCount > 0 ? rowsCount : "—"}</span>
              </button>
              <button
                className={`wf-tab-btn${selectedKey === "addedituser" ? " active" : ""}`}
                onClick={() => handleTabSelect("addedituser")}
              >
                <i className={`fa ${selectedUserId > 0 ? "fa-pencil-square-o" : "fa-user-plus"}`} />
                {selectedUserId > 0 ? "Edit" : "Add"} User
                {selectedUserId > 0 && (
                  <span className="wf-tab-badge">#{selectedUserId}</span>
                )}
              </button>
              <button
                className={`wf-tab-btn${selectedKey === "status" ? " active" : ""}${selectedUserId === 0 ? " tab-locked" : ""}`}
                onClick={() => handleTabSelect("status")}
                title="Activate or deactivate a user"
              >
                <i className="fa fa-toggle-on" />
                Activate / Deactivate
                {selectedUserId > 0 && (
                  <span className="wf-tab-badge">#{selectedUserId}</span>
                )}
              </button>
            </div>

            {/* ── Users Tab ── */}
            {selectedKey === "home" && (
              <div className="wf-tab-panel">

                {/* Selected user context card */}
                {selectedUserId > 0 && selectedObj && (
                  <div className="wf-assign-card">
                    <div className="wf-assign-info">
                      <div className="wf-assign-avatar">
                        {(selectedObj.name || "?").charAt(0).toUpperCase()}
                      </div>
                      <div className="wf-assign-meta">
                        <strong>{selectedObj.name}</strong>
                        <span>
                          {selectedObj.email}
                          {selectedObj.title && <> &bull; {selectedObj.title}</>}
                          &nbsp;&bull;&nbsp;
                          <span className={`badge-capsule ${selectedObj.status ? "badge-active" : "badge-inactive"}`} style={{ padding: "2px 8px", fontSize: 12 }}>
                            {selectedObj.status ? "Active" : "Inactive"}
                          </span>
                        </span>
                      </div>
                    </div>
                    <div className="wf-assign-actions">
                      <button
                        className="btn-action-search"
                        onClick={() => handleTabSelect("addedituser")}
                      >
                        Edit
                      </button>
                      <button
                        className="btn-action-search"
                        onClick={() => handleTabSelect("status")}
                      >
                        Status
                      </button>
                      <button
                        className="btn-action-search btn-danger-search"
                        onClick={handleResetSelection}
                        title="Clear selection"
                      >
                        ✕
                      </button>
                    </div>
                  </div>
                )}

                <div className="table-responsive mt-2 wf-table-scroll">
                  <table className="table align-items-center table-flush wf-table">
                    <thead className="wf-thead">
                      <tr>
                        <th>ID</th>
                        <th>Date Added</th>
                        <th>Name &amp; Title</th>
                        <th>Email</th>
                        <th>Login Type</th>
                        <th>Azure Email</th>
                        <th>Contact No.</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {isLoading ? (
                        Array.from({ length: pageSize > 5 ? 5 : pageSize }).map((_, i) => (
                          <tr key={`skel-${i}`} className="skeleton-row">
                            <td><span className="skeleton-cell sk-short" style={{ animationDelay: `${i * 0.05}s` }} /></td>
                            <td><span className="skeleton-cell sk-medium" style={{ animationDelay: `${i * 0.07}s` }} /></td>
                            <td><span className="skeleton-cell sk-long" style={{ animationDelay: `${i * 0.06}s` }} /></td>
                            <td><span className="skeleton-cell sk-full" style={{ animationDelay: `${i * 0.08}s` }} /></td>
                            <td><span className="skeleton-cell sk-medium" style={{ animationDelay: `${i * 0.05}s` }} /></td>
                            <td><span className="skeleton-cell sk-medium" style={{ animationDelay: `${i * 0.06}s` }} /></td>
                            <td><span className="skeleton-cell sk-short" style={{ animationDelay: `${i * 0.07}s` }} /></td>
                            <td><span className="skeleton-cell sk-short" style={{ animationDelay: `${i * 0.05}s` }} /></td>
                          </tr>
                        ))
                      ) : performers.length === 0 ? (
                        <tr>
                          <td colSpan={8} style={{ padding: 0 }}>
                            <div className="wf-empty-state">
                              <div className="wf-empty-icon">
                                <i className={dataType === "filter" ? "fa fa-search" : "fa fa-users"} aria-hidden="true" />
                              </div>
                              <p className="wf-empty-title">
                                {dataType === "filter" ? "No Matching Users" : "No Users Assigned"}
                              </p>
                              <p className="wf-empty-desc">
                                {dataType === "filter"
                                  ? "Try adjusting or resetting the filters to see users."
                                  : "There are no users assigned to this workflow role yet. Add a user to get started."}
                              </p>
                              {dataType === "filter" ? (
                                <button
                                  className="btn-action-search"
                                  onClick={handleFilterCancel}
                                  style={{ marginTop: 4 }}
                                >
                                  <i className="fa fa-refresh" aria-hidden="true" /> Reset Filters
                                </button>
                              ) : (
                                <button
                                  className="btn-action-search btn-primary-search"
                                  onClick={handleAddUser}
                                  style={{ marginTop: 4 }}
                                >
                                  <i className="fa fa-user-plus" /> Add First User
                                </button>
                              )}
                            </div>
                          </td>
                        </tr>
                      ) : (
                        performers.map((performer, idx) => (
                          <tr
                            key={performer.id}
                            className={`wf-table-row${selectedUserId === performer.id ? " selected-row" : ""}`}
                            onClick={() => handleSelectUser(performer)}
                            style={{ animationDelay: `${idx * 0.04}s` }}
                            title={selectedUserId === performer.id ? `Click to deselect: ${performer.name}` : `Click to select: ${performer.name}`}
                          >
                            <td>
                              <span>#{performer.id}</span>
                            </td>
                            <td>
                              <span className="wf-data-line">
                                {performer.addedDateTime ? (
                                  <Moment format="MMM Do YYYY">{performer.addedDateTime}</Moment>
                                ) : (
                                  <span className="wf-empty-value">Not available</span>
                                )}
                              </span>
                            </td>
                            <td>
                              <div className="wf-name-cell">
                                <span className="wf-name-avatar">{getInitials(performer)}</span>
                                <div className="wf-name-meta">
                                  <span className="wf-name-main">{getDisplayName(performer)}</span>
                                  {performer.title ? (
                                    <span className="wf-name-title">{performer.title}</span>
                                  ) : (
                                    <span className="wf-empty-value">No title</span>
                                  )}
                                </div>
                              </div>
                            </td>
                            <td>
                              <span className="wf-data-line wf-email-line">
                                {performer.email || <span className="wf-empty-value">No email</span>}
                              </span>
                            </td>
                            <td className="wf-login-type-cell">
                              {performer.loginType === 1 ? (
                                <span className="badge-capsule badge-azure">
                                  Azure AD
                                </span>
                              ) : (
                                <span className="badge-capsule badge-system">
                                  System
                                </span>
                              )}
                            </td>
                            <td className="wf-azure-email-cell">
                              {performer.azureEmailId ? (
                                <span className="wf-data-line wf-email-line">
                                  {performer.azureEmailId}
                                </span>
                              ) : (
                                <span className="wf-empty-value">Not linked</span>
                              )}
                            </td>
                            <td>
                              {performer.contact ? (
                                <span className="wf-data-line">
                                  {getFormatedNumber(performer.contact)}
                                </span>
                              ) : (
                                <span className="wf-empty-value">No contact</span>
                              )}
                            </td>
                            <td className="wf-status-cell">
                              {performer.status ? (
                                <span className="badge-capsule badge-active">
                                  Active
                                </span>
                              ) : (
                                <span className="badge-capsule badge-inactive">
                                  Inactive
                                </span>
                              )}
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>

                <div className="mt-3">
                  <Pagination
                    currentPage={currentPage}
                    pageSize={pageSize}
                    itemsCount={rowsCount}
                    onPageChange={handlePageChange}
                    startIndex={startIndex}
                    endIndex={endIndex}
                  />
                </div>
              </div>
            )}

            {/* ── Add / Edit User Tab ── */}
            {selectedKey === "addedituser" && (
              <div className="wf-tab-panel pt-2">
                <AddWorkflowPerformer
                  selectedObj={selectedObj}
                  currentUser={currentUser}
                  handleFormSubmit={handleFormSubmit}
                  handlePermissionShowHide={handlePermissionShowHide}
                />
              </div>
            )}

            {/* ── Activate / Deactivate Tab ── */}
            {selectedKey === "status" && (
              <div className="mt-3 bg-white p-3 rounded border wf-tab-panel">
                {selectedUserId > 0 ? (
                  <ActiveDeactiveHistory
                    selectedObj={selectedObj}
                    type="performer"
                    typeName="User"
                    actionType={actionType}
                    handlePermissionShowHide2={handlePermissionShowHide2}
                  />
                ) : (
                  <div className="wf-empty-state">
                    <div className="wf-empty-icon">
                      <i className="fa fa-toggle-on" aria-hidden="true" />
                    </div>
                    <p className="wf-empty-title">No User Selected</p>
                    <p className="wf-empty-desc">
                      Select a user from the <strong>Users</strong> tab to activate, deactivate, or review their status history.
                    </p>
                    <button
                      className="btn-action-search"
                      onClick={() => handleTabSelect("home")}
                      style={{ marginTop: 4 }}
                    >
                      <i className="fa fa-arrow-left" /> Back to Users
                    </button>
                  </div>
                )}
              </div>
            )}

          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
